// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2bOSM","noInteraction":"EventWrapper_noInteraction__3HlfS"};